import React, { Component } from 'react';

class Learning extends Component {
    render() {
        return (
            <div className="App">
              <h2>CURRENTLY LEARNING</h2>
              <h3>Scratch</h3>
              <h5>gaining expertise in block-based coding to teach children coding concepts </h5>
              🔆
              <h4>SVG: from JavaScript to drawing and fabrication</h4>
              🔆
            </div>
            )}
}
export default Learning 